module.exports = "/images/privacy_policy_icon.svg?a3a135a028655a99d017040f5f1965c8";